<template>
    <div>
        <Dialog v-if="viewSlots" :commonDialog="viewSlots" :dialogWidth="650">
            <template v-slot:title>Slot Schedule</template>
            <template v-slot:body>
                <v-container>
                    <table width="100%">
                        <thead>
                            <th>S.no</th>
                            <th>Slots</th>
                            <th>Slot Duration</th>
                            <th>Status</th>
                        </thead>
                        <template v-if="slotData.length > 0">
                            <tr v-for="(row, index) in slotData" :key="index">
                                <td class="font-size-14 font-weight-500" align="center" valign="middle">
                                    {{ index + 1 }}
                                </td>
                                <td>{{ row.start }}-{{ row.end }}</td>

                                <td>
                                    <v-text-field readonly solo flat dense filled hide-details
                                        :value="row.duration"></v-text-field>
                                </td>
                                <td>
                                    <v-switch v-model.trim="row.is_active" inset :true-value="1" :false-value="0"
                                        color="green" hide-details class="mt-0"></v-switch>
                                </td>
                                <td>
                                    <v-tooltip top content-class="custom-top-tooltip">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon @click="deleteSchedule(index)" color="deep-orange" v-bind="attrs"
                                                v-on="on">
                                                mdi-delete
                                            </v-icon>
                                        </template>
                                        <span>Click here to delete </span>
                                    </v-tooltip>
                                </td>
                            </tr>
                        </template>
                        <tr v-else>
                            <td colspan="6" class="py-4">
                                <p class="m-0 row-not-found text-center font-weight-500 font-size-16">
                                    <img :src="$assetURL('media/error/empty.png')" class="row-not-found-image" />
                                    Uhh... There are no slot at this moment.
                                </p>
                            </td>
                        </tr>
                    </table>
                </v-container>
            </template>
            <template v-slot:action>
                <v-btn class="mx-2 custom-grey-border custom-bold-button"
                    v-on:click="(viewSlots = !viewSlots), $emit('close-dialog', true)">
                    Close
                </v-btn>
                <v-btn class="mx-2 custom-grey-border custom-bold-button white--text" color="cyan"
                    v-on:click="updateSlots()">
                    Save
                </v-btn>
            </template>
        </Dialog>
    </div>

</template>
<script>
import Dialog from "@/view/pages/partials/Dialog.vue";

export default {
    data() {
        return {

        }
    },
    props:
    {
        slotData: {
            type: Array,
            default: null,
        },
        viewSlots: {
            type: Boolean,
            default: false,
        }
    },
    methods: {
        updateSlots() {
            this.$emit('sentUpdatedSlots', this.slotData);
        }
    },
    components: {
        Dialog
    },
    created() {
        this.viewSlotData = this.slotData;
    }
}















</script>